import { Button, Card, Skeleton } from "@rumbledirect/ui-v2";
import { createFileRoute, Link } from "@tanstack/react-router";
import { getApiErrorStatus } from "@/lib/api/apiErrorStatus";
import { useGetRootServicePartnersServicePartnerId } from "@/lib/api/generated/service-partner/service-partner";
import { ServicePartnerEditor } from "@/servicePartners/ServicePartnerEditor";
import { parseServicePartnersSearch } from "@/servicePartners/servicePartnersSearch";

export const Route = createFileRoute(
  "/_authenticated/platform-management_/service-partners_/$servicePartnerId",
)({ validateSearch: parseServicePartnersSearch, component: PartnerRoute });
function PartnerRoute() {
  const { servicePartnerId } = Route.useParams();
  const search = Route.useSearch();
  const navigate = Route.useNavigate();
  const query = useGetRootServicePartnersServicePartnerId(servicePartnerId);
  if (query.isPending)
    return (
      <Card
        role="status"
        aria-label="Hersteller laden"
        aria-live="polite"
        className="space-y-6 p-6"
      >
        <Skeleton className="h-20 w-full" />
        <Skeleton className="h-64 w-full" />
      </Card>
    );
  if (query.isError && !query.data)
    return (
      <Card role="alert" className="space-y-4 p-6">
        <p>
          {getApiErrorStatus(query.error) === 404
            ? "Deze hersteller bestaat niet."
            : "We konden deze hersteller niet laden."}
        </p>
        <Link to="/platform-management/service-partners" search={search}>
          Terug naar herstellers
        </Link>
        {getApiErrorStatus(query.error) !== 404 && (
          <Button variant="outline" onClick={() => void query.refetch()}>
            Opnieuw proberen
          </Button>
        )}
      </Card>
    );
  return (
    <>
      {query.isError && (
        <Card role="alert" className="mb-6 space-y-4 p-6">
          <p>We konden deze hersteller niet vernieuwen.</p>
          <Button variant="outline" onClick={() => void query.refetch()}>
            Opnieuw proberen
          </Button>
        </Card>
      )}
      <ServicePartnerEditor
        key={servicePartnerId}
        partner={query.data}
        onBack={() => {
          void navigate({
            to: "/platform-management/service-partners",
            search,
          });
        }}
      />
    </>
  );
}
